import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { guide } from 'src/api';

class ModulesAction extends ActionBasic<ModulesState> {

    /*************** 比较新手指导版本大小 **************/
    /** 将版本转化为数字 */
    private guideVersionToNum = (version) => {
        version = version.toString();
        const num = version.split(/\D/);
        const num_place = ["", "0", "00", "000", "0000"], num_reverse = num_place.reverse();
        for (let i = 0; i < num.length; i++) {
            const len = num[i].length;
            num[i] = num_reverse[len] + num[i];
        }
        var res = num.join('');
        return res;
    } 
    /** 比较版本大小 */
    private  compareVersion = (version1, version2) => {
        const _version1 = this.guideVersionToNum(version1), _version2 = this.guideVersionToNum(version2);
        if (_version1 === _version2){
            return false;
        }
        if (_version1 > _version2){
            return false;
        }
        if (_version1 < _version2){
            return true;
        }
    }

     /** 获取新手版本 */
     public getCurrentGuideVersion = async () => {
        const guideInfoRes:any = await guide.getCurrentAccountInfo(this);
        if(!guideInfoRes.er && guideInfoRes.res){
            const guideInfo = guideInfoRes.res;
            return !guideInfo.guideVersion || this.compareVersion(guideInfo.guideVersion, this.modulesState.GUIDE_VERSION);
        }
        return false;
        // return true;
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/modules/Home/Modules.Action.ts